var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 349,
    viewBox: "0 0 346 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45531 223.655C12.3304 255.024 27.7266 275.475 51.8994 285.928C95.2093 304.655 124.912 292.914 156.244 298.194C187.575 303.474 199.725 326.241 225.105 341.311C244.916 353.074 288.461 349.477 311.683 326.077C334.593 302.991 351.273 277.592 341.647 235.959C332.307 194.728 302.549 175.904 290.343 132.774C278.136 89.6435 283.32 52.7225 260.68 31.0361C236.939 8.29551 174.585 -12.4062 132.732 12.8586C99.0683 33.1801 94.5737 76.5233 63.3628 99.9445C32.1519 123.366 18.3106 134.514 11.8667 153.109C2.95844 178.816 -1.97992 198.022 4.45531 223.655Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterLasso);
export default __webpack_public_path__ + "static/media/register-lasso.202bf1eaaec96ddeed00703409a2d370.svg";
export { ForwardRef as ReactComponent };